import React, {useEffect, useState} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Box from '@material-ui/core/Box';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import IconButton from '@material-ui/core/IconButton';
import Link from '@material-ui/core/Link';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
// @ts-ignore
import {useBranch} from 'baobab-react/hooks';
import InstanceActions from '../data/InstanceActions';
import SettingsActions from '../data/SettingsActions';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import InputLabel from '@material-ui/core/InputLabel';
import {logout} from '../data/api';

function KubeOutput({kubeOut, onClose}: any) {
    return (
        <Dialog open={true} aria-labelledby="form-dialog-title">
            <DialogTitle id="form-dialog-title">Kube output</DialogTitle>
            <DialogContent>
                <pre>{kubeOut}</pre>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary">
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
}

function EditSettings({overseerVersions, settings, onSave, onCancel}: any) {
    const v = settings.find((s: any) => s.key === 'overseer_version');
    const [version, setVersion] = useState(v ? v.value : '');
    if (!overseerVersions || !settings) {
        return null;
    }
    const save = () => {
        onSave({
            version,
        });
    };
    return (
        <Dialog open={true} aria-labelledby="form-dialog-title">
            <DialogTitle id="form-dialog-title">Settings</DialogTitle>
            <DialogContent>
                <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={version}
                    onChange={(e) => setVersion(e.target.value)}
                >
                    {overseerVersions.tags.map((ov: any) => (
                        <MenuItem key={ov} value={ov}>
                            {ov}
                        </MenuItem>
                    ))}
                </Select>
            </DialogContent>
            <DialogActions>
                <Button onClick={onCancel} color="primary">
                    Cancel
                </Button>
                <Button onClick={save} color="primary">
                    Save
                </Button>
            </DialogActions>
        </Dialog>
    );
}

function EditInstance({instance, onSave, onCancel}: any) {
    const [name, setName] = useState(instance.name);
    const [version, setVersion] = useState(instance.version);
    const [status, setStatus] = useState(instance.status || 'running');
    const [minReplicas, setMinReplicas] = useState(instance.minReplicas || 1);
    const [maxReplicas, setMaxReplicas] = useState(instance.maxReplicas || 1);
    const [adminEmail, setAdminEmail] = useState(instance.adminEmail);
    const [adminName, setAdminName] = useState(instance.adminName);
    const [adminPassword, setAdminPassword] = useState(instance.adminPassword);
    const [company, setCompany] = useState(instance.company);
    const [requestsMemory, setRequestsMemory] = useState(instance.requestsMemory || '0Mi');
    const [requestsCPU, setRequestsCPU] = useState(instance.requestsCPU || '0m');
    const [priority, setPriority] = useState(instance.priority || 'low-priority');
    const [limitsMemory, setLimitsMemory] = useState(instance.limitsMemory || '2048Mi');
    const [limitsCPU, setLimitsCPU] = useState(instance.limitsCPU || '1000m');
    const [type, setType] = useState(instance.type || 'APPLICATION');
    const [useWorkers, setUseWorkers] = useState(instance.useWorkers?.toString() || false.toString());

    const statuses = ['turned_off', 'running', 'sleep'];
    const reqMemOptions = ['0Mi', '128Mi', '256Mi', '512Mi', '1024Mi', '1280Mi', '1536Mi', '2048Mi', '4096Mi'];
    const reqCPUOptions = ['0m', '10m', '100m', '200m', '500m', '750m', '1000m', '2000m'];
    const priorityOptions = ['low-priority', 'medium-priority', 'high-priority'];
    const typeOptions = ['APPLICATION', 'WORKER'];
    const userWorkersOptions = [false.toString(), true.toString()];

    const save = () => {
        onSave({
            id: instance.id,
            name: name,
            version: version,
            status: status,
            minReplicas: parseInt(minReplicas),
            maxReplicas: parseInt(maxReplicas),
            adminEmail: adminEmail,
            adminPassword: adminPassword,
            adminName: adminName,
            company: company,
            requestsMemory: requestsMemory,
            requestsCPU: requestsCPU,
            priority: priority,
            limitsMemory: limitsMemory,
            limitsCPU: limitsCPU,
            type: type,
            useWorkers: JSON.parse(useWorkers),
        });
    };

    return (
        <Dialog open={true} aria-labelledby="form-dialog-title">
            <DialogTitle id="form-dialog-title">Instance data</DialogTitle>
            <DialogContent>
                <FormGroup style={{width: 400}}>
                    <FormControl>
                        <TextField
                            autoFocus
                            margin="dense"
                            id="name"
                            label="Instance name"
                            type="name"
                            fullWidth
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                        />
                    </FormControl>
                    <FormControl>
                        <TextField
                            margin="dense"
                            id="version"
                            label="Version"
                            fullWidth
                            value={version}
                            onChange={(e) => setVersion(e.target.value)}
                        />
                    </FormControl>
                    <FormControl>
                        <TextField
                            margin="dense"
                            id="adminEmail"
                            label="Admin email"
                            fullWidth
                            value={adminEmail}
                            onChange={(e) => setAdminEmail(e.target.value)}
                        />
                    </FormControl>
                    <FormControl>
                        <TextField
                            margin="dense"
                            id="adminName"
                            label="Admin name"
                            fullWidth
                            value={adminName}
                            onChange={(e) => setAdminName(e.target.value)}
                        />
                    </FormControl>
                    <FormControl>
                        <TextField
                            margin="dense"
                            id="adminPassword"
                            label="Admin password"
                            fullWidth
                            value={adminPassword}
                            onChange={(e) => setAdminPassword(e.target.value)}
                        />
                    </FormControl>
                    <FormControl>
                        <TextField
                            margin="dense"
                            id="company"
                            label="Company"
                            fullWidth
                            value={company}
                            onChange={(e) => setCompany(e.target.value)}
                        />
                    </FormControl>
                    <FormControl>
                        <InputLabel>Status</InputLabel>
                        <Select id="status" value={status} onChange={(e) => setStatus(e.target.value)}>
                            {statuses.map((ov) => (
                                <MenuItem key={ov} value={ov}>
                                    {ov}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <FormControl>
                        <InputLabel>Requests Memory</InputLabel>
                        <Select
                            id="requestsMemory"
                            value={requestsMemory}
                            onChange={(e) => setRequestsMemory(e.target.value)}
                        >
                            {reqMemOptions.map((ov) => (
                                <MenuItem key={ov} value={ov}>
                                    {ov}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <FormControl>
                        <InputLabel>Requests CPU</InputLabel>
                        <Select id="requestsCPU" value={requestsCPU} onChange={(e) => setRequestsCPU(e.target.value)}>
                            {reqCPUOptions.map((ov) => (
                                <MenuItem key={ov} value={ov}>
                                    {ov}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <FormControl>
                        <InputLabel>Limits Memory</InputLabel>
                        <Select
                            id="limitsMemory"
                            value={limitsMemory}
                            onChange={(e) => setLimitsMemory(e.target.value)}
                        >
                            {reqMemOptions.map((ov) => (
                                <MenuItem key={ov} value={ov}>
                                    {ov}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <FormControl>
                        <InputLabel>Limits CPU</InputLabel>
                        <Select id="limitsCPU" value={limitsCPU} onChange={(e) => setLimitsCPU(e.target.value)}>
                            {reqCPUOptions.map((ov) => (
                                <MenuItem key={ov} value={ov}>
                                    {ov}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <FormControl>
                        <Select id="priority" value={priority} onChange={(e) => setPriority(e.target.value)}>
                            {priorityOptions.map((ov) => (
                                <MenuItem key={ov} value={ov}>
                                    {ov}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <FormControl>
                        <TextField
                            id="minReplicas"
                            label="Min replicas"
                            type="number"
                            value={minReplicas}
                            onChange={(e) => setMinReplicas(e.target.value)}
                        />
                    </FormControl>
                    <FormControl>
                        <TextField
                            id="maxReplicas"
                            label="Max replicas"
                            type="number"
                            value={maxReplicas}
                            onChange={(e) => setMaxReplicas(e.target.value)}
                        />
                    </FormControl>
                    <FormControl>
                        <InputLabel>Type</InputLabel>
                        <Select id="type" value={type} onChange={(e) => setType(e.target.value)}>
                            {typeOptions.map((ov) => (
                                <MenuItem key={ov} value={ov}>
                                    {ov}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <FormControl>
                        <InputLabel>Use workers</InputLabel>
                        <Select id="useWorkers" value={useWorkers} onChange={(e) => setUseWorkers(e.target.value)}>
                            {userWorkersOptions.map((ov) => (
                                <MenuItem key={ov} value={ov}>
                                    {ov}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </FormGroup>
            </DialogContent>
            <DialogActions>
                <Button onClick={onCancel} color="primary">
                    Cancel
                </Button>
                <Button onClick={save} color="primary">
                    Save
                </Button>
            </DialogActions>
        </Dialog>
    );
}

function Copyright() {
    return (
        <Typography variant="body2" color="textSecondary" align="center">
            {'Copyright © '}
            <Link color="inherit" href="https://www.farseer.io/">
                Farseer
            </Link>{' '}
            {new Date().getFullYear()}
            {'.'}
        </Typography>
    );
}

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
    },
    toolbar: {
        paddingRight: 24,
    },
    toolbarIcon: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: '0 8px',
        ...theme.mixins.toolbar,
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
    },
    title: {
        flexGrow: 1,
    },
    appBarSpacer: theme.mixins.toolbar,
    content: {
        flexGrow: 1,
        height: '100vh',
        overflow: 'auto',
    },
    container: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
    },
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
    },
}));

export default function Main() {
    const classes = useStyles();
    const [editingInstance, setEditingInstance] = useState(null);
    const [createInstanceActive, setCreateInstanceActive] = useState(false);
    const [settingsActive, setSettingsActive] = useState(false);
    const [kubeOutputActive, setKubeOutputActive] = useState(false);
    const [kubeOutput, setKubeOutput] = useState('');

    const saveSettings = (settings: any) => {
        console.log('save settings', settings);
        SettingsActions.updateSettings([{key: 'overseer_version', value: settings.version}]);
        setSettingsActive(false);
    };
    const cancelSettings = () => {
        setSettingsActive(false);
    };
    const showSettings = () => {
        setSettingsActive(true);
    };
    const createInstance = () => {
        setCreateInstanceActive(true);
    };
    const editInstance = (instance: any) => {
        setEditingInstance({...instance});
    };
    const deleteInstance = (instance: any) => {
        InstanceActions.deleteInstance(instance);
    };
    const onSave = (instance: any) => {
        if (editingInstance) {
            InstanceActions.editInstance(instance);
        } else {
            InstanceActions.createInstance(instance);
        }
        setCreateInstanceActive(false);
        setEditingInstance(null);
    };
    const onCancel = () => {
        setEditingInstance(null);
        setCreateInstanceActive(false);
    };
    const {instances, settings, overseerVersions} = useBranch({
        instances: ['instances'],
        settings: ['settings'],
        overseerVersions: ['overseerVersions'],
    });

    const checkKubectl = () => {
        InstanceActions.checkKubectl().then((resp) => {
            console.log(resp);
            setKubeOutput(resp.output);
            setKubeOutputActive(true);
        });
    };

    useEffect(() => {
        InstanceActions.getInstances();
        SettingsActions.getSettings();
        SettingsActions.getAvailableOverseerVersions();
    }, []);

    return (
        <div className={classes.root}>
            <CssBaseline/>
            <AppBar position="absolute" className={classes.appBar}>
                <Toolbar className={classes.toolbar}>
                    <Typography component="h1" variant="h6" color="inherit" noWrap className={classes.title}>
                        Overseer
                    </Typography>
                    <Button onClick={checkKubectl} color="inherit">
                        Check kube
                    </Button>
                    <Button onClick={showSettings} color="inherit">
                        Settings
                    </Button>
                    <Button onClick={createInstance} color="inherit">
                        Create instance
                    </Button>
                    <Button onClick={logout} color="inherit">
                        Logout
                    </Button>
                </Toolbar>
            </AppBar>

            <main className={classes.content}>
                <div className={classes.appBarSpacer}/>
                <Container maxWidth="lg" className={classes.container}>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <Paper className={classes.paper}>
                                <React.Fragment>
                                    <Typography component="h2" variant="h6" color="primary" gutterBottom>
                                        Instances
                                    </Typography>
                                    <Table size="small">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Name</TableCell>
                                                <TableCell>Version</TableCell>
                                                <TableCell>Status</TableCell>
                                                <TableCell>Replicas</TableCell>
                                                <TableCell>Type</TableCell>
                                                <TableCell align="right"></TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {instances && Array.isArray(instances)
                                                ? instances.map((instance) => (
                                                    <TableRow key={instance.id}>
                                                        <TableCell>{instance.name}</TableCell>
                                                        <TableCell>{instance.version}</TableCell>
                                                        <TableCell>{instance.status}</TableCell>
                                                        <TableCell>{instance.minReplicas}</TableCell>
                                                        <TableCell>{instance.type}</TableCell>
                                                        <TableCell align="right">
                                                            <IconButton onClick={() => editInstance(instance)}>
                                                                <EditIcon/>
                                                            </IconButton>
                                                            <IconButton onClick={() => deleteInstance(instance)}>
                                                                <DeleteIcon/>
                                                            </IconButton>
                                                        </TableCell>
                                                    </TableRow>
                                                ))
                                                : null}
                                        </TableBody>
                                    </Table>
                                </React.Fragment>
                            </Paper>
                        </Grid>
                    </Grid>
                    <Box pt={4}>
                        <Copyright/>
                    </Box>
                </Container>
                {editingInstance !== null ? (
                    <EditInstance instance={editingInstance} onSave={onSave} onCancel={onCancel}/>
                ) : null}
                {createInstanceActive ? <EditInstance instance={{}} onSave={onSave} onCancel={onCancel}/> : null}
                {settingsActive ? (
                    <EditSettings
                        overseerVersions={overseerVersions}
                        settings={settings}
                        onSave={saveSettings}
                        onCancel={cancelSettings}
                    />
                ) : null}
                {kubeOutputActive ? (
                    <KubeOutput kubeOut={kubeOutput} onClose={() => setKubeOutputActive(false)}/>
                ) : null}
            </main>
        </div>
    );
}
